module.exports = __webpack_public_path__ + "static/zakaria-14964c902a10d363835148f64e424e03.png";